module.exports = __webpack_public_path__ + "img/title3_0.7364dfc5.png";